"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _history = require("history");

var _Functions = require("UIComponents/core/Functions");

var AbstractRouterLink = function AbstractRouterLink(props) {
  var component = props.component,
      to = props.to,
      replace = props.replace,
      onClick = props.onClick,
      rest = (0, _objectWithoutProperties2.default)(props, ["component", "to", "replace", "onClick"]);
  var history = (0, _reactRouterDom.useHistory)();
  var handleClick = (0, _react.useCallback)(function (e) {
    (0, _Functions.callIfPossible)(onClick, e);

    if (e.defaultPrevented) {
      return;
    }

    if (e && !e.metaKey) {
      e.preventDefault();

      if (replace) {
        history.replace(to);
      } else {
        history.push(to);
      }
    }
  }, [history, onClick, replace, to]);
  var href = (0, _react.useMemo)(function () {
    var location = typeof to === 'string' ? (0, _history.createLocation)(to, null, null, history.location) : to;
    return history.createHref(location);
  }, [history, to]);
  return _react.default.createElement(component, (0, _extends2.default)({}, rest, {
    href: href,
    onClick: handleClick
  }));
};

AbstractRouterLink.propTypes = {
  component: _propTypes.default.elementType.isRequired,
  onClick: _propTypes.default.func,
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  replace: _propTypes.default.bool
};
AbstractRouterLink.defaultProps = {
  replace: false
};
var _default = AbstractRouterLink;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-react-router-dom/static-1.2601/js/internal/AbstractRouterLink.js
// module id = 760
// module chunks = 209 210 211 212